'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _immutable = require('immutable');

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  switch (action.type) {
    case 'UPDATE_DEPENDENTS_START':
      return state.setIn([action.acct_id, 'dependents'], (0, _immutable.fromJS)({ loading: true }));

    case 'UPDATE_DEPENDENTS':
      return state.setIn([action.acct_id, 'dependents'], (0, _immutable.fromJS)(action.payload));

    case 'ADD_DEPENDENT':
      return state.updateIn([action.acct_id, 'dependents'], function (dependents) {
        return dependents.push((0, _immutable.fromJS)(action.payload));
      });

    case 'UPDATE_DEPENDENT':
      return state.updateIn([action.acct_id, 'dependents'], function (dependents) {
        var i = dependents.findIndex(function (d) {
          return d.get('id') === action.person.id;
        });
        var dep = {};
        if (!action.school_id) {
          var updatedDep = action.payload;
          delete updatedDep.school;
          dep = _extends({}, dependents.toJS()[i], updatedDep);
        } else {
          dep = _extends({}, dependents.toJS()[i], { school: action.payload.school });
        }
        return dependents.setIn([i], (0, _immutable.fromJS)(dep));
      });

    case 'DELETE_DEPENDENTS':
      return state.deleteIn([action.acct_id, 'dependents']);

    case 'GET_MY_FEISEANNA':
      action.payload.forEach(function (f) {
        var feis = f.feis,
            withoutFeisDetails = _objectWithoutProperties(f, ['feis']);

        state = state.setIn([action.acct_id, 'feiseanna', f.feis.id], (0, _immutable.fromJS)(withoutFeisDetails));
      });
      return state;

    case 'GET_UNPAID_ACCOUNTS_FOR_FEIS':
      var newState = state;
      action.payload.map(function (a) {
        return newState = newState.setIn([a.id, 'one'], (0, _immutable.fromJS)(a));
      });
      return newState;

    case 'GET_FEISEANNA_FOR_ACCOUNT':
      var ns = state;
      action.payload.map(function (f) {
        var accFeis = Object.assign({}, f);
        accFeis.feis_id = f.feis.id;
        delete accFeis.feis;
        ns = ns.setIn([action.acct_id, 'feiseanna', accFeis.feis_id], (0, _immutable.fromJS)(accFeis));
      });
      return ns;

    case 'GET_PAYMENTS_FOR_ACCOUNT':
      var balance = state.getIn([action.acct_id, 'balances', action.feis_id, 'balance']) || 0;
      var newStoreState = state;
      if (balance > action.payload.amt) {
        balance = balance - action.payload.amt;
        newStoreState = state.setIn([action.acct_id, 'balances', action.feis_id], (0, _immutable.fromJS)({ balance: balance }));
      }
      return newStoreState.setIn([action.acct_id, 'payments'], (0, _immutable.fromJS)(action.payload));

    case 'UPDATE_CART':
      return state.setIn([action.acct_id, 'balances', action.feis_id], (0, _immutable.fromJS)({ balance: action.payload.balance }));

    case 'GET_BALANCES_FOR_ACCOUNT':
      action.payload.forEach(function (f) {
        var balance = f.balance;

        state = state.setIn([action.acct_id, 'balances', f.feis.id], (0, _immutable.fromJS)(balance));
      });
      return state;

    case 'GET_MY_COMPETITORS_FOR_FEIS':
      return state.setIn([action.acct_id, 'competitors', action.feis_id], (0, _immutable.fromJS)(action.payload));

    case 'ATTACH_FEIS':
      return state.setIn([action.acct_id, 'feiseanna', action.feis_id, 'saved'], 1);

    case 'DETACH_FEIS':
      return state.setIn([action.acct_id, 'feiseanna', action.feis_id, 'saved'], 0);

    case 'GET_PURCHASED_PRODUCTS_BY_ACCOUNT_FOR_FEIS':
      return state.setIn([action.acct_id, 'feiseanna', action.feis_id, 'products'], (0, _immutable.fromJS)(action.payload));

    case 'PURCHASE_PRODUCT':
      return state.setIn([action.acct_id, 'feiseanna', action.feis_id, 'products'], (state.getIn([action.acct_id, 'feiseanna', action.feis_id, 'products']) || (0, _immutable.List)()).filter(function (product) {
        return product.get('id') !== action.payload.id;
      }).push((0, _immutable.fromJS)(action.payload)));

    case 'RETURN_PRODUCT':
      return state.setIn([action.acct_id, 'feiseanna', action.feis_id, 'products'], (state.getIn([action.acct_id, 'feiseanna', action.feis_id, 'products']) || (0, _immutable.List)()).filter(function (product) {
        return product.get('id') !== action.purchase_id;
      }));

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/accounts/index.js
// module id = 687
// module chunks = 0